import { IInventoryItemTethering } from './IInventoryItemTethering';
import { IInventoryItemType } from './IInventoryItemType';
import { IInventoryManufacturerItem } from './IInventoryManufacturerItem';
import { IInventoryTemplateItemGroup } from './IInventoryTemplateItemGroup';
import { IInventoryVendorManufacturerItem } from './IInventoryVendorManufacturerItem';

export interface IInventoryItem {
  itemInstructions: string;
  hasSerialNumber: boolean;
  hasTethering: boolean;
  isActive: boolean;
  itemGroup?: IInventoryTemplateItemGroup;
  itemGroupId?: string;
  itemGroupName?: string;
  itemGroupInstructions?: string;
  itemId: string;
  itemName: string;
  itemType: IInventoryItemType;
  manufacturerPartNumber?: string;
  partNumber?: string;
  preferredManufacturer?: string;
  preferredVendor?: string;
  tethering?: IInventoryItemTethering;
  unitPrice?: number;
  vendorManufacturerItem?: IInventoryVendorManufacturerItem[];
  manufacturerItems?: IInventoryManufacturerItem[];
}
